/** @file Names a mixDefaults pair may use: every animation name and every `@DIR` base (`walk` of `walk@SE`). */
import type { Doc } from './schema';

/** Animation names plus their `@DIR` bases, skipping animation ids in `removed`. */
export function mixNames(animations: Doc['animations'], removed?: ReadonlyMap<string, unknown>): Set<string> {
  const out = new Set<string>();
  for (const [id, anim] of Object.entries(animations)) {
    if (removed?.has(id)) continue;
    out.add(anim.name);
    out.add(anim.name.split('@')[0] ?? anim.name);
  }
  return out;
}
